import React, { useState } from "react";
import { object, func, array, string } from "prop-types";
import get from "lodash/get";

import Button from "../../atoms/button";
import OtherPaymentsView from "../other-payments-view";
import PopupModal from "../../atoms/popup-modal";

import { makeRazorpayPayment, getPaymentOptions } from "../../helper/access-type"; // eslint-disable-line
import { sendTransactionalEmail } from "../../helper/api";
import { setCookie } from "../../helper/cookies";

import "./payButtonView.m.css";

const PayButtonView = ({ member, plan, plans, setLoading, currentPath = "" }) => {
  const [isOtherPaymentOptions, setIsOtherPaymentOptions] = useState(false);
  const [otherPaymentOptions, setOtherPaymentOptions] = useState({});

  const otherOptionsClick = () => setIsOtherPaymentOptions(!isOtherPaymentOptions);

  const paymentClick = () => {
    if (!plan.title) {
      console.log("not a valid plan");
      return;
    }

    window.dataLayer.push({
      event: "payment_initiated",
      selected_plan: `${plan.title} - ${plan.recurring ? "Recurring" : "oneTime"}`,
      discount_details: "none",
      plan_value: plan.price_cents / 100,
    });

    getPaymentOptions().then((paymentOptions) => {
      if (paymentOptions.razorpay || paymentOptions.juspay) {
        if (plan.recurring) {
          setLoading(true);
          makeRazorpayPayment(plan, paymentOptions).then(paymentSuccessful).catch(paymentFailed);
        } else {
          setIsOtherPaymentOptions(true);
          setOtherPaymentOptions(paymentOptions);
        }
      } else {
        console.log("Payment Gateway Unavailable", paymentOptions, plan);
      }
    });
  };

  const paymentSuccessful = (response) => {
    setLoading(false);

    console.log("paymentSuccessful", response);

    const queryParams = window.location.search || "";
    const utmSrc = queryParams.split("?utm_source=")[1];
    window.dataLayer.push({
      payment: `Payment successful from ${utmSrc}`,
    });

    const initiatePage = window.localStorage.getItem("plan_initiate_page");
    const initiatePosition = window.localStorage.getItem("plan_initiate_position");

    window.localStorage.removeItem("plan_initiate_page");
    window.localStorage.removeItem("plan_initiate_position");

    window.dataLayer.push({
      event: "payment_completed",
      sym_initiate_page: initiatePage,
      sym_initiate_position: initiatePosition,
    });
    const options = {
      userEmail: member.email,
      userName: member.name,
      gaAction: initiatePage,
      gaLabel: initiatePosition,
      paymentMode: get(response, ["subscription", "payment_type"], ""),
    };

    setCookie("status", "success", 600);
    sendTransactionalEmail(options);
    window.location.href = "/";
  };

  const paymentFailed = (e) => {
    setLoading(false);
    console.log(e);
  };

  const otherPaymentOptionsView = () => {
    if (!isOtherPaymentOptions) {
      return null;
    }

    return (
      <PopupModal closePopup={otherOptionsClick}>
        <OtherPaymentsView
          plan={plan}
          plans={plans}
          otherPaymentOptions={otherPaymentOptions}
          member={member}
          closePopup={otherOptionsClick}
          sucessCallback={paymentSuccessful}
          failureCallback={paymentFailed}
          currentPath={currentPath}
        />
      </PopupModal>
    );
  };

  return (
    <div styleName="pay-support-wrapper">
      <Button
        content="Pay & Support"
        className="pay-and-support"
        buttonType="type2"
        id="membership-payment"
        onClick={paymentClick}
      />

      <p styleName="terms-conditions">
        By subscribing you agree to our <span>T&C.</span>
      </p>
      {otherPaymentOptionsView()}
    </div>
  );
};

PayButtonView.propTypes = {
  member: object,
  plan: object,
  setLoading: func,
  plans: array,
  currentPath: string,
};

export default PayButtonView;
